import {TRIGGER_SIGNAL_TYPE} from '@constants/administration/machine/trigger-signal-label';

export class AdditionalMessageField {
  value: string | boolean | number;
  fieldName: string;
  dataType: 'string' | 'boolean' | 'number' | 'eventSeverity';

  constructor({value, fieldName, dataType} = {} as AdditionalMessageField) {
    this.value = value || AdditionalMessageField.getEmptyValue(dataType);
    this.fieldName = fieldName || '';
    this.dataType = dataType || 'string';
  }

  private static getEmptyValue(dataType: 'string' | 'boolean' | 'number' | 'eventSeverity'): number | string | boolean {
    switch (dataType) {
      case 'number':
        return 0;
      case 'boolean':
        return false;
      case 'string':
        return '';
      case 'eventSeverity':
        return TRIGGER_SIGNAL_TYPE.ERROR;
      default:
        return '';
    }
  }
}

export enum AdditionalMessageFieldTypes {
  EventCodeUniversal = 'EventCodeUniversal',
  EventCodeNative = 'EventCodeNative',
  EventCreated = 'EventCreated',
  EventSeverity = 'EventSeverity',
  AdditionalInformation = 'AdditionalInformation',
  EventDescription = 'EventDescription',
}
